<template>
  <div class="my-clock-in" v-if="myClockIn.id">
    <div class="my-clock-in-header">
      <div class="line"></div>
      <div class="title">我的打卡</div>
      <div class="line"></div>
    </div>
    <ClockInCard
      :key="myClockIn.id"
      myStyle="
            background: linear-gradient(360deg, rgba(255, 255, 255, 0.5) 0%, #fff6ef 100%);
            border-radius: 8px;
            border: 0.5px solid #e7e7e7;
          "
      :dataObj="myClockIn"
      :isEdit="true"
      :noLongPress="true"
      size="26.93vw"
      @star="handlerStar"
      @clickComment="handlerComment"
      @loadMoreComment="handlerLoadMoreComment"
      @edit="handlerEditClockIn"
    />

    <ClockInComment
      :show.sync="showInput"
      :cardId="commentData.user_punch_id"
      :replyId="commentData.reply_id"
      :replyName="commentData.name"
      @success="handlerCommentSuccess"
    />
  </div>
</template>

<script>
import {
  myClockInData,
  getMoreComments
} from '@/api/clockin';
import ClockInCard from '@/components/clockInCard/index.vue';
import ClockInComment from '@/components/ClockInComment/index.vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store/index';
import router from '@/router';

export default {
  props: {
    detailId: {
      type: Number,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  components: {
    ClockInCard,
    ClockInComment
  },
  setup(props) {
    const myClockIn = ref({});

    const setMyClockIn = () => {
      myClockInData(props.detailId).then((res) => {
        const data = res.data.user_punch_data;

        myClockIn.value = {
          id: data.id,
          myData: data.user,
          level: data.level,
          date: data.create_time,
          isTop: data.top_time,
          content: data.content,
          video: data.video_url,
          record: data.multi_voices,
          img: data.multi_images,
          star: data.like_user_metas,
          commentCount: data.comment_count,
          commentList: data.comment_items,
          groupName: data.group.name || ''
        };

        if (!store.state.user) {
          store.commit('SET_USER_DATA', data.user);
        }
      });
    };

    setMyClockIn();

    watch(() => props.detailId, () => {
      setMyClockIn();
    });

    const handlerStar = (data) => {
      if (data.isLike) {
        myClockIn.value.star.push(store.state.user);
        return;
      }

      const index = myClockIn.value.star.findIndex(
        item => item.id === store.state.user.id
      );

      myClockIn.value.star.splice(index, 1);
    };

    const showInput = ref(false);
    const commentData = ref({
      user_punch_id: '', // 用户打卡ID
      reply_id: '', // 回复的评论ID
      name: '', // 回复的人的名字
    });
    const handlerComment = (data) => {
      commentData.value = {
        ...commentData.value,
        ...data,
      };
      showInput.value = true;
    };
    const handlerCommentSuccess = (data) => {
      showInput.value = false;
      myClockIn.value.commentList.push(data);
      myClockIn.value.commentCount += 1;
    };
    const handlerLoadMoreComment = (data) => {
      const {
        // eslint-disable-next-line camelcase
        up_id,
        limit,
        // eslint-disable-next-line camelcase
        last_id,
      } = data;

      getMoreComments({ up_id, limit, last_id }).then((res) => {
        const value = res.data;
        const comments = value.items.filter(item => !myClockIn.value.commentList.some(val => val.id === item.id));

        myClockIn.value.commentList.push(...comments);
        myClockIn.value.commentCount = value.count;
      });
    };

    const handlerEditClockIn = () => {
      router.push(`/clock-in/${props.detailId}/${props.date.replace(/\//g, '-')}/1`);
    };

    // 响应打卡详情页、打卡页对数据的修改
    const updateData = computed(() => store.state.isUpdateCard);
    watch(updateData, (val) => {
      if (myClockIn.value.id !== val.id) {
        return;
      }

      if (val.isWho === 1) {
        store.commit('SET_ISUPDATE_CARD', {
          id: '',
          isWho: 0
        });

        // 更新点赞列表
        if (val.stars) {
          myClockIn.value.star.push(store.state.user);
          return;
        }

        const index = myClockIn.value.star.findIndex(
          item => item.id === store.state.user.id
        );

        if (index === -1) {
          return;
        }

        myClockIn.value.star.splice(index, 1);
      } else if (val.isWho === 2) {
        store.commit('SET_ISUPDATE_CARD', {
          id: '',
          isWho: 0
        });

        // 更新评论列表
        if (myClockIn.value.commentList.length >= 5) {
          myClockIn.value.commentCount += 1;
          return;
        }

        const data = {
          up_id: myClockIn.value.id,
          limit: 5
        };

        if (myClockIn.value.commentList.length) {
          data.last_id = myClockIn.value.commentList[myClockIn.value.commentList.length - 1].id;
        }

        getMoreComments(data).then((res) => {
          const value = res.data;
          const comments = value.items.filter(item => !myClockIn.value.commentList.some(ele => ele.id === item.id));

          myClockIn.value.commentList.push(...comments);
          myClockIn.value.commentCount = value.count;
        });
      }
    }, { deep: true });

    return {
      myClockIn,
      showInput,
      commentData,
      handlerStar,
      handlerComment,
      handlerCommentSuccess,
      handlerLoadMoreComment,
      handlerEditClockIn
    };
  }
};
</script>

<style lang="stylus" scoped>
.my-clock-in {
  padding: 0 10px;
  padding-bottom: 20px;
  background: #fff;

  .my-clock-in-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    padding: 20px 0;

    .line {
      width: 70px;
      height: 1px;
      background: #dadada;
    }

    .title {
      margin: 0 10px;
      font-size: 14px;
      color: #dadada;
    }
  }
}
</style>
